let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <deliveryOrder>
        <code>单号, string (50) , 必填</code>
        <type>类型, string (50), express=快递, 必填</type>
        <weight>重量, double (18,3)</weight>
    </deliveryOrder>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <deliveryOrder>
        <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
        <ownerCode>货主编码, string (50), 必填</ownerCode>
        <deliveryOrderCode>出库单号, string (50), 必填</deliveryOrderCode>
        <deliveryOrderId>仓储系统出库单号, string (50), 条件必填</deliveryOrderId>
        <orderType>出库单类型, string (50),必填</orderType>
        <status>出库单状态, string (50)</status>
        <shopNick>店铺名称, string (50)</shopNick>
        <logisticsName>物流公司编码, string (50),</logisticsName>
        <expressCode>运单号, string (50)</expressCode>
        <createTime>创建时间, string (19), YYYY-MM-DD HH:MM:SS</createTime>
        <updateTime>更新时间, string (19), YYYY-MM-DD HH:MM:SS</updateTime>
    </deliveryOrder>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

let NotificaitonURL = 'NotificaitonURL'

export default { xmlRequest, xmlResponse, NotificaitonURL }




// WEBPACK FOOTER //
// ./src/data/openapi/openapi.stockout.close.js